// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"635":"124296df","703":"5617b2b9"}[chunkId] + ".chunk.js";
};